<div class="outlet-wrapper p-shadow-24 p-component">
	<router-outlet></router-outlet>
</div>